import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ReporteEstadoEntregasPage from "./reporte-estado-entregas";
import ReporteResumenEntregasPage from "./reporte-resumen-entregas";

const RouterReportes = () => {
  const { path } = useRouteMatch();
  // console.log('routerAdministracion');
  // console.log(path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}/reporte-estado-entregas`}>
        <ReporteEstadoEntregasPage />
      </Route>
      <Route exact path={`${path}/reporte-resumen-entregas`}>
        <ReporteResumenEntregasPage />
      </Route>


      {/* <Route exact path={`${path}`}>
        <AdministracionIndex />
      </Route> */}

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterReportes;
